import { useEffect, useMemo, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { UserPlus } from "lucide-react";
import { toast } from "sonner";

export const LinkParentDialog = ({ child, parents, onClose, onLinked, onCreateParent }) => {
  const [q, setQ] = useState("");
  useEffect(() => { if (child) setQ(""); }, [child]);
  const matches = useMemo(() => {
    const t = q.trim().toLowerCase();
    return (t ? parents.filter((p) => `${p.name} ${p.email} ${p.phone || ""}`.toLowerCase().includes(t)) : parents).slice(0, 8);
  }, [q, parents]);
  const link = async (p) => {
    try { await api.post(`/admin/children/${child.id}/link-parent`, { parent_id: p.id }); toast.success(`${child.first_name} linked to ${p.name}`); onLinked(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Dialog open={!!child} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-2xl" data-testid="link-parent-dialog">
        <DialogHeader><DialogTitle className="font-display text-navy">Link a parent to {child?.first_name}</DialogTitle></DialogHeader>
        <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search parent name, email or phone…" className="rounded-xl" data-testid="link-parent-search" />
        <div className="space-y-1 max-h-64 overflow-y-auto">
          {matches.map((p) => (
            <button key={p.id} onClick={() => link(p)} className="w-full text-left rounded-xl border border-slate-200 px-3 py-2 hover:border-turquoise hover:bg-turquoise/5 transition-colors" data-testid={`link-parent-pick-${p.id}`}>
              <span className="font-semibold text-navy">{p.name}</span> <span className="text-xs text-slate-400">{p.email}</span>
            </button>
          ))}
          {!matches.length && <p className="text-sm text-slate-400">No matching parent.</p>}
        </div>
        <Button variant="outline" onClick={() => onCreateParent(child)} className="rounded-full" data-testid="link-parent-create"><UserPlus className="w-4 h-4 mr-1" />Create a new parent account</Button>
      </DialogContent>
    </Dialog>
  );
};
